import axios, { http } from './axios'
import Cookies from './cookie'
import EventEmitter from './events'
import indexDB from './indexDB'
import _ from './lodash-es'
import localStorage from './localStorage'
import memoryCache from './memoryCache'
import sessionStorage from './sessionStorage'
import CatchError from './catchError'
// import Logger from './logger';

import utils from './utils'
// import '../demo/axios'
// import '../demo/cookie'
// import '../demo/lodash-es'
// import '../demo/utils'
// import '../demo/indexDB'
// import '../demo/memoryCache'
// import '../demo/sessionStorage'
// import '../demo/sessionStorage1'

// import {axios} from 'ynf-core-middleware'
// axios.get('1.json')
if (typeof window.load2ndLangResource !== 'function') {
  import("./lang/index")
}

export {
  axios,
  http,
  memoryCache,
  EventEmitter,
  indexDB,
  Cookies,
  localStorage,
  sessionStorage,
  utils,
  CatchError,
  _
}
export default {
  axios,
  http,
  memoryCache,
  EventEmitter,
  indexDB,
  Cookies,
  CatchError,
  localStorage,
  sessionStorage,
  utils,
  _
}
// indexedDB.init('myindexDB', 1, [{ tableName: 'test' }]).then((dbInstance) => {
//   dbInstance.insert({ tableName: 'test', data: { a: 1, b: 2 } }).then(res => {
//     console.log(res);
//   })
// })

// localStorage.setItem('a', 1)
// sessionStorage.setItem('a', 1)
// Cookies.set('d', 1244)
// console.log(Cookies.get('d'));
// export default {
//   axios,
//   dayjs,
//   memoryCache,
//   EventEmitter,
//   utils
// }
// console.log(dayjs().format('{YYYY} MM-DDTHH:mm:ss SSS [Z] A'));
// const a = utils.clone({ a: 1 })
// const b = clone({ b: 1 })
// console.log(a);
// console.log(b);
